@if (loaderSpiner$ | async; as loader) {
  @if (loader.showSpinner) {
    <div class="overlay">
      <div class="loader-container">
        <img src="/assets/img/git/loader.gif" alt="Loading" class="loader-img"/>
        <span class="loading-desc">{{ loader?.message?.length > 0 ? loader.message : message }}</span>
      </div>
    </div>
  }
}
